export default "__VITE_ASSET__9aVL482F__"